//wishlist icons

(function () {
	// helper: switch a <path> to currentColor
	function useCurrentColor(path) {
		if (path.getAttribute('stroke') !== 'currentColor') {
			path.setAttribute('stroke', 'currentColor');
		}
	}

	// 1) Fix any already-rendered hearts
	document
		.querySelectorAll('.ooo-wl-button-icon--heart path')
		.forEach(useCurrentColor);

	// 2) Watch for newly-injected hearts
	var observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			mutation.addedNodes.forEach(function (node) {
				if (node.nodeType !== 1) return;
				// if it *is* a path
				if (node.matches && node.matches('.ooo-wl-button-icon--heart path')) {
					useCurrentColor(node);
				}
				// or if it *contains* paths
				node.querySelectorAll &&
					node
						.querySelectorAll('.ooo-wl-button-icon--heart path')
						.forEach(useCurrentColor);
			});
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
})();

// Accessibility fix: Wishlist Power app injects buttons inside shadow DOM with
// role="checkbox" but no aria-label. We add the label once the shadow root exists.
(function () {
	function fixWishlistButton(el) {
		if (!el.shadowRoot) return;
		var btn = el.shadowRoot.querySelector('button[role="checkbox"]');
		if (btn && !btn.getAttribute('aria-label')) {
			var card = el.closest('product-card, .product-card');
			var title = card && card.querySelector('.product-title') ? card.querySelector('.product-title').textContent.trim() : '';
			btn.setAttribute('aria-label', title ? title + ', wishlist' : 'Wishlist');
		}
	}

	// Fix already-rendered buttons
	document.querySelectorAll('ooo-wl-product-card-button').forEach(fixWishlistButton);

	// Watch for newly-injected buttons
	var wlObserver = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			mutation.addedNodes.forEach(function (node) {
				if (node.nodeType !== 1) return;
				if (node.tagName && node.tagName.toLowerCase() === 'ooo-wl-product-card-button') {
					fixWishlistButton(node);
				}
				if (node.querySelectorAll) {
					node.querySelectorAll('ooo-wl-product-card-button').forEach(fixWishlistButton);
				}
			});
		});
	});

	wlObserver.observe(document.body, { childList: true, subtree: true });

	// Also retry after a delay since shadow roots may not be ready immediately
	setTimeout(function () {
		document.querySelectorAll('ooo-wl-product-card-button').forEach(fixWishlistButton);
	}, 2000);
})();

//product size and add to cart logic

// Cart drawer discount code functionality
document.addEventListener('DOMContentLoaded', function () {
  // Initialize discount code functionality
  initializeDiscountCodeForm();
  
  // Initialize discount removal functionality
  initializeDiscountRemoval();
});

function initializeDiscountCodeForm() {
  // Listen for discount form submission
  document.addEventListener('submit', function(event) {
    if (event.target.matches('[data-discount-form]')) {
      event.preventDefault();
      
      const form = event.target;
      const input = form.querySelector('[data-discount-input]');
      const messageEl = form.querySelector('[data-discount-message]');
      const button = form.querySelector('.discount-code-button');
      const code = input.value.trim();
      
      if (!code) {
        showDiscountMessage(messageEl, 'Please enter a discount code', 'error');
        return;
      }
      
      // Disable button and show loading state
      button.disabled = true;
      button.textContent = 'Applying...';
      
      // Use Shopify's cart API to apply discount
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: code
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.token) {
          // Success - refresh cart
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          showDiscountMessage(messageEl, 'Discount code applied successfully!', 'success');
          input.value = '';
        } else if (data.discount_codes && data.discount_codes.length > 0) {
          // Check if discount was applied
          const appliedDiscount = data.discount_codes.find(dc => dc.code === code);
          if (appliedDiscount && appliedDiscount.applicable) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            showDiscountMessage(messageEl, 'Discount code applied successfully!', 'success');
            input.value = '';
          } else {
            showDiscountMessage(messageEl, 'Invalid discount code', 'error');
          }
        } else {
          // Error handling
          showDiscountMessage(messageEl, 'Invalid discount code', 'error');
        }
      })
      .catch(error => {
        console.error('Discount code error:', error);
        showDiscountMessage(messageEl, 'Error applying discount code', 'error');
      })
      .finally(() => {
        // Re-enable button
        button.disabled = false;
        button.textContent = 'Apply';
      });
    }
  });
}

function showDiscountMessage(messageEl, text, type) {
  messageEl.textContent = text;
  messageEl.className = `discount-code-message ${type}`;
  
  // Auto-hide success messages after 3 seconds
  if (type === 'success') {
    setTimeout(() => {
      messageEl.className = 'discount-code-message';
    }, 3000);
  }
}

function initializeDiscountRemoval() {
  // Listen for discount removal button clicks
  document.addEventListener('click', function(event) {
    if (event.target.matches('[data-discount-remove]')) {
      event.preventDefault();
      
      const button = event.target;
      const discountCode = button.getAttribute('data-discount-remove');
      
      if (!discountCode) return;
      
      // Disable button and show loading state
      button.disabled = true;
      button.innerHTML = '{%- render "icon" with "close", width: 12 -%}';
      
      // Remove discount by setting it to empty
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: ''
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.token) {
          // Success - refresh cart
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(error => {
        console.error('Discount removal error:', error);
      })
      .finally(() => {
        // Re-enable button
        button.disabled = false;
        button.innerHTML = '{%- render "icon" with "close", width: 12 -%}';
      });
    }
  });
}

// Product size selection and Add to Cart logic
document.addEventListener('DOMContentLoaded', function () {
	// Find the hidden input used to track selected variant

	const preselectedId = document.getElementById('preselected-id');
	
	// Always initialize 2-step quick add regardless of page type
	initialize2StepQuickAdd();
	
	// Early return if not on a product page
	if (!preselectedId) return;

	// Check if we have a valid variant ID in the URL that should bypass SELECT SIZE logic
	const urlParams = new URLSearchParams(window.location.search);
	const variantId = urlParams.get('variant');
	
	// Find the Add to Cart button by its custom data attribute (can be add-to-cart, pre-order, notify-me, etc.)
	const addToCartBtn = document.querySelector('.shopify-product-form button[data-custom-id]');
	const fieldSet = document.querySelector('.variant-picker__option[data-option="Size"]');
	const variantInventory = document.querySelector('.product-info variant-inventory');


	function setupWishlistIcon() {

		const wishlistElement = document.querySelector('ooo-wl-product-page-button');
		const wishlistButtonContainer = wishlistElement;
		const wishlistButton = wishlistElement ? wishlistElement.shadowRoot.querySelector('button.button--fill') : null;
		const wishlistHeartButton = document.querySelector('.product .product-gallery .wishlist-product-button');

		if (!wishlistHeartButton) return;
		if (!wishlistButtonContainer) return;
		if (!wishlistButton) return;

		// Debug: Check if the template exists
		console.log('1. Template element:', document.getElementById('ooo-wl-product-page-button'));

		// Debug: Look for the actual rendered button (not in template)
		console.log('2. Rendered button.button--fill:', document.querySelector('button.button--fill'));

		// Debug: Check if the wishlist app has rendered the button elsewhere
		console.log('3. All button.button--fill elements:', document.querySelectorAll('button[class*="button--fill"]'));

		// Debug: Look for any buttons with wishlist-related classes
		console.log('4. Buttons with ooo-wl classes:', document.querySelectorAll('button[class*="ooo-wl"]'));

		// Debug: Check if the wishlist app has created a shadow DOM
		
		console.log('5. Wishlist element:', wishlistElement);
		console.log('6. Shadow root:', wishlistElement ? wishlistElement.shadowRoot : 'No wishlist element found');

		// Debug: Look for the button inside the shadow DOM
		if (wishlistElement && wishlistElement.shadowRoot) {
			console.log('7. Button in shadow DOM:', wishlistElement.shadowRoot.querySelector('button.button--fill'));
		} else {
			console.log('7. No shadow DOM available');
		}

		// Debug: Check if the app has moved the button to a different location
		console.log('8. Buttons with data-state:', document.querySelectorAll('button[data-state="add"], button[data-state="remove"]'));

		// Debug: Look for any button with wishlist text
		console.log('9. Buttons with wishlist text:', Array.from(document.querySelectorAll('button')).filter(btn => 
			btn.textContent.includes('wishlist') || btn.textContent.includes('Add to') || btn.textContent.includes('Remove from')
		));

		// Debug: Check all buttons in the product info area
		console.log('10. All buttons in product-info:', document.querySelectorAll('.product-info button'));

		// Debug: Check the current selectors we're using
		console.log('11. Current container selector result:', wishlistButtonContainer);
		console.log('12. Current button selector result:', wishlistButton);

		function updateHeartState() {
			wishlistHeartButton.removeAttribute('disabled');
			
			// Check if the wishlist button is checked (has aria-checked="true")
			const isAdded = wishlistButton.getAttribute('aria-checked') === 'true';
			
			console.log('Heart state check:', {
				ariaChecked: wishlistButton.getAttribute('aria-checked'),
				isAdded: isAdded,
				buttonClasses: wishlistButton.className
			});
			
			if (isAdded) {
				console.log('added');
				wishlistHeartButton.classList.add('checked');
				wishlistHeartButton.classList.remove('unchecked');
			} else {
				console.log('removed');
				wishlistHeartButton.classList.add('unchecked');
				wishlistHeartButton.classList.remove('checked');
			}
		}

		// Initialize state
		setTimeout(updateHeartState, 600);

		wishlistHeartButton.addEventListener('click', function (e) {
			e.stopPropagation();

			wishlistButton.click();
			wishlistHeartButton.setAttribute('disabled', '');
			// Poll until wishlistButton is no longer disabled
			function waitUntilEnabled() {
				if (!wishlistButton.hasAttribute('disabled')) {
					updateHeartState();
				} else {
					setTimeout(waitUntilEnabled, 100); // check every 100ms
				}
			}

			waitUntilEnabled();
		});
	}


	if (!addToCartBtn) return;
	if (!fieldSet) return;

	// Utility: check if a valid variant is selected
	function isVariantSelected() {
		// If we have a variant ID in the URL, consider it selected
		if (variantId) {
			return true;
		}
		// Otherwise check the preselectedId value
		return preselectedId.value && preselectedId.value !== '';
	}

	// Update the Add to Cart button state & label
	function updateButtonState() {
		// Find the sticky add to cart button
		const stickyAddToCartBtn = document.querySelector('.product-sticky-bar button[data-custom-id]');
		
		if (isVariantSelected()) {
			// Main button
			addToCartBtn.removeAttribute('disabled');
			addToCartBtn.classList.remove('disabled');
			addToCartBtn.classList.remove('select-size-disabled');
			
			// Don't override the button text if it's already set correctly by the theme
			// Only restore original label if we previously changed it to "Select size"
			if (addToCartBtn.classList.contains('select-size-disabled')) {
				addToCartBtn.textContent = addToCartBtn.dataset.originalLabel || 'Add to cart';
			}
			// Otherwise, let the theme's button text remain (for pre-order, notify me, etc.)

			// Sticky button
			if (stickyAddToCartBtn) {
				stickyAddToCartBtn.removeAttribute('disabled');
				stickyAddToCartBtn.classList.remove('disabled');
				stickyAddToCartBtn.classList.remove('select-size-disabled');
				
				// Restore original label if we previously changed it to "Select size"
				if (stickyAddToCartBtn.classList.contains('select-size-disabled')) {
					stickyAddToCartBtn.textContent = stickyAddToCartBtn.dataset.originalLabel || 'Add to cart';
				}
			}

			if (variantInventory) variantInventory.classList.add('opacity-1');

		} else {
			if (variantInventory) variantInventory.classList.add('opacity-0');

			// Main button
			addToCartBtn.setAttribute('disabled', 'disabled');
			addToCartBtn.classList.add('disabled');
			// Store the original label (only once)
			if (!addToCartBtn.dataset.originalLabel) {
				addToCartBtn.dataset.originalLabel = addToCartBtn.textContent;
			}
			addToCartBtn.textContent = 'Select size';
			addToCartBtn.classList.add('select-size-disabled');
			
			// Sticky button
			if (stickyAddToCartBtn) {
				// Keep sticky button enabled so it can be clicked to scroll up
				stickyAddToCartBtn.removeAttribute('disabled');
				stickyAddToCartBtn.classList.remove('disabled');
				// Store the original label (only once)
				if (!stickyAddToCartBtn.dataset.originalLabel) {
					stickyAddToCartBtn.dataset.originalLabel = stickyAddToCartBtn.textContent;
				}
				stickyAddToCartBtn.textContent = 'Select size';
				stickyAddToCartBtn.classList.add('select-size-disabled');
				
				// Add click handler for sticky button to scroll to product title
				stickyAddToCartBtn.onclick = function(e) {
					if (stickyAddToCartBtn.classList.contains('select-size-disabled')) {
						e.preventDefault();
						e.stopPropagation();
						
						// Scroll to product title
						const productTitle = document.querySelector('.product-info__block-item[data-block-type="title"]');
						if (productTitle) {
							productTitle.scrollIntoView({ behavior: 'smooth', block: 'center' });
						}
						return false;
					}
				};
			}
			
			// Only clear size selections if we don't have a variant ID in URL
			if (!variantId) {
				let sizeOptionValues = document.querySelectorAll('.variant-picker__option[data-option="Size"] .variant-picker__option-values input[type="radio"]');
				for (let sizeOptionValue of sizeOptionValues) {
					sizeOptionValue.checked = false;
					sizeOptionValue.removeAttribute('checked');
				}
			}
		}
	}

	// Listen for the custom "variant:change" event (fired by your variant picker)
	document.addEventListener('variant:change', function (e) {
		// Extract variant ID if available
		const variant = e.detail && e.detail.variant;
		if (variant && variant.id) {
			preselectedId.value = variant.id;
			preselectedId.removeAttribute('disabled');
		} else {
			preselectedId.value = '';

			preselectedId.setAttribute('disabled', 'disabled');

		}
		updateButtonState();
		
		// Update size selection when variant changes
		// This handles both user-initiated changes and theme auto-switches
		const urlParams = new URLSearchParams(window.location.search);
		const urlVariantId = urlParams.get('variant');
		
		if (variant && variant.options && variant.options.length >= 2) {
			const newSize = variant.options[1]; // Second option is size
			const newColor = variant.options[0]; // First option is color
			
			// Update the data attribute on all variant picker options
			document.querySelectorAll('.variant-picker__option[data-current-size]').forEach(picker => {
				picker.dataset.currentSize = newSize;
			});
			
			// Update color swatch URLs if the function exists
			if (typeof updateColorSwatchURLs === 'function') {
				updateColorSwatchURLs();
			}
			
			// Update current page URL
			const newUrl = new URL(window.location);
			newUrl.searchParams.set('variant', variant.id);
			window.history.replaceState({}, '', newUrl);
		}
	});


	setupWishlistIcon();

	// Set initial button state on page load
	updateButtonState();
	
	// Setup color swatch URL management
	// Add a small delay to ensure DOM is fully loaded
	setTimeout(() => {
		setupColorSwatchURLs();
	}, 100);

	// 2-Step Quick Add to Cart functionality
	// initialize2StepQuickAdd(); // This line is moved outside the conditional block
});

// 2-Step Quick Add to Cart functionality
function initialize2StepQuickAdd() {
	// Check if 2-step quick add is enabled
	const quickAddElements = document.querySelectorAll('.product-card__quick-add-2step-button');
	
	// Use event delegation for dynamically loaded content
	document.addEventListener('click', function (e) {
		// Quick Add button at bottom
		if (e.target.closest('.product-card__quick-add-2step-button')) {
			e.preventDefault();
			e.stopPropagation();

			const button = e.target.closest('.product-card__quick-add-2step-button');
			const productId = button.dataset.productId;
			const productHandle = button.dataset.productHandle;
			
			const quickAddBottom = button.closest('.product-card__quick-add-bottom');
			const sizeRow = quickAddBottom ? quickAddBottom.querySelector('.product-card__size-row') : null;
			
			if (sizeRow) {
				// Multiple variants detected - showing size row
				button.style.display = 'none';
				sizeRow.style.display = 'flex';
			} else {
				// Single variant detected - adding to cart directly
				addToCartDirectly(productId, button);
			}
		}

		// Size option click
		if (e.target.closest('.product-card__size-option')) {
			e.preventDefault();
			e.stopPropagation();

			const sizeOption = e.target.closest('.product-card__size-option');
			const variantId = sizeOption.dataset.variantId;
			const productId = sizeOption.dataset.productId;
			
			const quickAddBottom = sizeOption.closest('.product-card__quick-add-bottom');
			const button = quickAddBottom ? quickAddBottom.querySelector('.product-card__quick-add-2step-button') : null;
			const sizeRow = quickAddBottom ? quickAddBottom.querySelector('.product-card__size-row') : null;
			
			addToCartWithVariant(variantId, productId);
			
			// Hide size row, show button again
			if (sizeRow && button) {
				sizeRow.style.display = 'none';
				button.style.display = 'block';
			}
		}
	});

	// Reset Quick Add state when mouse leaves product card
	document.addEventListener('mouseleave', function (e) {
		// Check if target is an element node and has the closest method
		if (e.target && e.target.nodeType === 1 && e.target.closest && e.target.closest('.product-card')) {
			const productCard = e.target.closest('.product-card');
			const quickAddBottom = productCard.querySelector('.product-card__quick-add-bottom');
			
			if (quickAddBottom) {
				const button = quickAddBottom.querySelector('.product-card__quick-add-2step-button');
				const sizeRow = quickAddBottom.querySelector('.product-card__size-row');
				
				if (button && sizeRow) {
					// Reset to initial state: show button, hide size row
					button.style.display = 'block';
					sizeRow.style.display = 'none';
				}
			}
		}
	});
}

function showSizePicker(modal) {
	modal.style.display = 'flex';
	document.body.style.overflow = 'hidden';
}

function closeSizePicker() {
	const modals = document.querySelectorAll('.product-card__size-picker-modal');
	modals.forEach(modal => {
		modal.style.display = 'none';
	});
	document.body.style.overflow = '';
}

function addToCartDirectly(productId, button) {
	// For single variant products, we need to fetch the product data to get the variant ID
	fetch(`/products/${button.dataset.productHandle}.js`)
		.then(response => response.json())
		.then(product => {
			// Get the first available variant
			const firstVariant = product.variants.find(variant => variant.available);
			if (!firstVariant) {
				throw new Error('No available variants found');
			}

			// Add variant to cart
			const formData = new FormData();
			formData.append('id', firstVariant.id);
			formData.append('quantity', '1');

			setButtonAddingState(button, true);

			return fetch('/cart/add.js', {
				method: 'POST',
				body: formData
			});
		})
		.then(response => response.json())
		.then(async data => {
			if (data.status === 422) {
				throw new Error(data.description);
			}
			
			// Trigger cart refresh to update cart count and data
			document.dispatchEvent(new CustomEvent('cart:refresh'));
			
			// Open the cart drawer manually
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) {
				cartDrawer.show();
			}
		})
		.catch(error => {
			console.error('Error adding to cart:', error);
			// Show error message
			showErrorMessage(error.message || 'Error adding to cart');
		})
		.finally(() => {
			setButtonAddingState(button, false);
		});
}

function addToCartWithVariant(variantId, productId) {
	// Find the button for this product to show loading state
	const button = document.querySelector(`[data-product-id="${productId}"].product-card__quick-add-2step-button`);
	if (button) {
		setButtonAddingState(button, true);
	}

	// Add variant to cart
	const formData = new FormData();
	formData.append('id', variantId);
	formData.append('quantity', '1');

	fetch('/cart/add.js', {
		method: 'POST',
		body: formData
	})
		.then(response => {
			return response.json();
		})
		.then(async data => {
			if (data.status === 422) {
				throw new Error(data.description);
			}
			
			// Trigger cart refresh to update cart count and data
			document.dispatchEvent(new CustomEvent('cart:refresh'));
			
			// Open the cart drawer manually
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) {
				cartDrawer.show();
			}
		})
		.catch(error => {
			console.error('Error adding to cart:', error);
			// Show error message
			showErrorMessage(error.message || 'Error adding to cart');
		})
		.finally(() => {
			if (button) {
				setButtonAddingState(button, false);
			}
		});
}

function setButtonAddingState(button, isAdding) {
	if (isAdding) {
		button.classList.add('adding');
		button.disabled = true;
	} else {
		button.classList.remove('adding');
		button.disabled = false;
	}
}

function showErrorMessage(message) {
	// Create a simple error notification
	const notification = document.createElement('div');
	notification.style.cssText = `
		position: fixed;
		top: 20px;
		right: 20px;
		background: #cb2b2b;
		color: white;
		padding: 1rem;
		border-radius: 4px;
		z-index: 10000;
		font-family: var(--text-font-family);
		max-width: 300px;
	`;
	notification.textContent = message;

	document.body.appendChild(notification);

	// Remove after 3 seconds
	setTimeout(() => {
		if (notification.parentNode) {
			notification.parentNode.removeChild(notification);
		}
	}, 3000);
}
// Color swatch URL management
function setupColorSwatchURLs() {
	// Build variant lookup from all grouped products
	const variantLookup = {};
	
	// Get all color swatches
	const colorSwatches = document.querySelectorAll('.product-info__block-item[data-block-type="product-variations"] .color-swatch');
	
	// Extract product handles from each swatch's href
	const productHandles = new Set();
	colorSwatches.forEach(swatch => {
		const href = swatch.getAttribute('href');
		if (href) {
			const productUrl = href.split('?')[0];
			const productHandle = productUrl.split('/products/')[1];
			if (productHandle) {
				productHandles.add(productHandle);
			}
		}
	});
	
	// Fetch product data for all grouped products
	Promise.all(Array.from(productHandles).map(handle => 
		fetch(`/products/${handle}.js`)
			.then(response => response.json())
			.catch(error => {
				return null;
			})
	)).then(products => {
		// Build complete variant lookup dictionary: { color: { size: variantId } }
		products.forEach(product => {
			if (product) {
				// Add all variants for this product to the lookup
				product.variants.forEach(variant => {
					if (variant.options.length >= 2) {
						const color = variant.options[0]; // First option is color
						const size = variant.options[1];  // Second option is size
						
						// Initialize color dictionary if it doesn't exist
						if (!variantLookup[color]) {
							variantLookup[color] = {};
						}
						
						// Add size -> variant mapping for this color
						variantLookup[color][size] = {
							variantId: variant.id,
							productHandle: product.handle,
							url: `/products/${product.handle}?variant=${variant.id}`
						};
					}
				});
			}
		});
		
		// Function to detect current variant from URL and update size data attributes
		function detectCurrentVariantAndUpdateSize() {
			// Get variant ID from URL
			const urlParams = new URLSearchParams(window.location.search);
			const variantId = urlParams.get('variant');
			
			if (variantId) {
				// If variant ID exists in URL, we have a specific variant selected
				// Find the variant in our lookup to get the size
				for (const color in variantLookup) {
					for (const size in variantLookup[color]) {
						if (variantLookup[color][size].variantId == variantId) {
							// Update all variant picker data attributes with the correct size
							document.querySelectorAll('.variant-picker__option[data-current-size]').forEach(picker => {
								picker.dataset.currentSize = size;
							});
							
							return size;
						}
					}
				}
			}
			
			// If no variant ID in URL, use data attribute or default (fallback for no size selected)
			const variantPicker = document.querySelector('.variant-picker__option[data-current-size]');
			return variantPicker?.dataset.currentSize || 'M';
		}
		
		// Function to update color swatch URLs based on current size
		function updateColorSwatchURLs() {
			// Get current size from the variant picker data attribute
			const currentSize = detectCurrentVariantAndUpdateSize();
			
			// Update each color swatch URL
			colorSwatches.forEach(swatch => {
				const colorName = swatch.getAttribute('data-color');
				
				if (!colorName) {
					return;
				}
				
				// Look up the variant for this color + size combination
				const colorVariants = variantLookup[colorName];
				
				if (colorVariants && colorVariants[currentSize]) {
					const targetVariant = colorVariants[currentSize];
					// Update the href to point to the correct variant
					swatch.href = targetVariant.url;
				}
			});
		}
		
		// Make updateColorSwatchURLs function globally accessible
		window.updateColorSwatchURLs = updateColorSwatchURLs;
		
		// Initial update
		updateColorSwatchURLs();
	});
}



const accordions = document.querySelectorAll('accordion-disclosure[data-accordion-mode]');

accordions.forEach(accordion => {
	const details = accordion.querySelector('details');
	if (details) {
		details.addEventListener('toggle', () => {
			if (details.open && accordion.hasAttribute('data-accordion-group')) {
				const groupName = accordion.getAttribute('data-accordion-group');

				document.querySelectorAll(`accordion-disclosure[data-accordion-group="${groupName}"]`).forEach(otherAccordion => {
					if (otherAccordion !== accordion) {
						const otherDetails = otherAccordion.querySelector('details');
						if (otherDetails && otherDetails.open) {
							// We can't just set otherDetails.open = false, as the theme's JS component handles animation.
							// Instead, we click the summary to trigger the theme's built-in toggle logic.
							otherDetails.querySelector('summary').click();
						}
					}
				});
			}
		});
	}
});

